import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import {Box} from "@chakra-ui/react"
import carouselStyles from "./productCarousel.module.css"
import {Products} from "./Products"
import {useState} from "react"
import {CustomDots} from "./CustomDots"

export const ProductCarousel = ({products, showPreProd = false}) => {
	const [currentSlide, setCurrentSlide] = useState(0)

	const settings = {
		speed: 500,
		infinite: true,
		slidesToShow: products?.length > 3 ? 4 : 2,
		slidesToScroll: 1,
		initialSlide: 0,
		afterChange: setCurrentSlide,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
				},
			},
			{
				breakpoint: 360,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	}

	return (
		<Box className={carouselStyles.carousel}>
			<div style={{width: "90%", margin: "auto"}}>
				<Slider {...settings}>
					{products?.map((item, key) => (
						<Products
							key={key}
							props={item}
						/>
					))}
				</Slider>
				<CustomDots
					totalDots={products}
					dotLength={"90%"}
					currentSlide={currentSlide}
					setCurrentSlide={setCurrentSlide}
				/>
			</div>
		</Box>
	)
}
